import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-forest relative overflow-hidden" data-id="element-243" data-mp="1d0cpnrg32dfu">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-244" data-mp="1rqjzxjvxsq5g"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-245" data-mp="1mtbdv87o41yx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-246" data-mp="z2fsotxpw50n">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-247" data-mp="17zq36d2pnq4i">
            <span className="text-2xl" data-id="element-248" data-mp="2jgy76x9g3485">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-cream" data-id="element-249" data-mp="2jferp8vm4x7f">
            El sistema más completo de producción agropecuaria para el aula de
            habla hispana.
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-250" data-mp="2bxtecxo0t9yu">
            Mega Pack Educación Agropecuaria en el Aula
          </h3>
          <p className="text-base md:text-lg text-cream-dark mb-10" data-id="element-251" data-mp="2kvvpw75drl0d">
            5 tomos · 4 bonos estratégicos · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-252" data-mp="1t57kuk0l5vhf">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-forest-dark p-6 rounded-2xl border border-forest-light" data-id="element-253" data-mp="1t72agbmsybru">
            <div className="flex items-start gap-3" data-id="element-254" data-mp="19g6zt6wty5vc">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-255" data-mp="19fdzoosdmem6" />
              <p className="text-cream-dark text-sm" data-id="element-256" data-mp="1eeqovg6pzxrx">
                No es teoría copiada de un manual universitario.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-257" data-mp="2cse4hhyjwrre">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-258" data-mp="2crvy3si6cx5r" />
              <p className="text-cream-dark text-sm" data-id="element-259" data-mp="2qihglg3pv534">
                No es una colección de actividades sueltas sin contexto.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-260" data-mp="1ysd3m2iadkbx">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-261" data-mp="1yswjzesag0nu" />
              <p className="text-cream-dark text-sm" data-id="element-262" data-mp="1tu1rfl4iqxqj">
                No es material que tengas que adaptar entero antes de usarlo.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-263" data-mp="22tgh4icv349z">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-264" data-mp="3msi6yjyd7d7e"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-265" data-mp="3qpe9sm5o5qdr">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-266" data-mp="3ctiwqwxyb9ia" />
              <p className="text-cream font-medium text-base leading-relaxed" data-id="element-267" data-mp="3hq9bngy0rz24">
                Es un sistema para que entres al aula con confianza y dictes
                clases que de verdad enseñen a producir.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}